import type { TextFieldProps } from '@mui/material';
import { TextField } from '@mui/material';
import type { FormikProps } from 'formik';

type Props<ID, T> = TextFieldProps & { id: ID; formik: FormikProps<T> };

export function FormikNumberField<
  ID extends string,
  T extends { [key in ID]?: number },
>(props: Props<ID, T>): JSX.Element {
  const { formik, ...textProps } = props;
  return (
    <TextField
      autoComplete="off"
      fullWidth
      {...textProps}
      disabled={formik.isSubmitting || props.disabled}
      error={
        (formik.touched[props.id] && Boolean(formik.errors[props.id])) ||
        props.error
      }
      helperText={(formik.errors[props.id] as string) || props.helperText}
      name={props.name ?? props.id}
      onBlur={formik.handleBlur}
      onChange={formik.handleChange}
      value={formik.values[props.id] ?? ''}
    />
  );
}
